import { createSelector } from 'reselect';

const selectGlobalOBNDBNBizs = (state: any) => state.globalOBNDBNBizs;

export const selectGlobalOBNDBNBizsCurrentItem = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.current);

export const selectGlobalOBNDBNBizsListItems = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.list);

export const selectGlobalOBNDBNBizsItemById = (itemId: any) =>
    createSelector(selectGlobalOBNDBNBizsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectGlobalOBNDBNBizsQueryItems = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.query);

export const selectGlobalOBNDBNBizsCreatedItem = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.create);

export const selectGlobalOBNDBNBizsUpdatedItem = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.update);

export const selectGlobalOBNDBNBizsReadItem = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.read);

export const selectGlobalOBNDBNBizsDeletedItem = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.delete);

export const selectGlobalOBNDBNBizsSearchedItems = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.search);

export const selectGlobalOBNDBNBizsItemsCount = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.count);

export const selectGlobalOBNDBNBizsItemsFilter = createSelector([selectGlobalOBNDBNBizs], (globalOBNDBNBizs) => globalOBNDBNBizs.filter);